import React, { useCallback } from 'react';
import { IconArrow, SettingsItem, SettingsItemRightContent, } from 'design-system';
export const StepCard = ({ step, onStepPress }) => {
    const onPress = useCallback(() => {
        onStepPress(step);
    }, [onStepPress, step]);
    const { id, icon, title, description } = step;
    return (<SettingsItem key={id} iconSize={44} icon={icon} title={title} description={description} onPress={onPress}>
      <SettingsItemRightContent>
        <IconArrow />
      </SettingsItemRightContent>
    </SettingsItem>);
};
